
import Auth from '../../api/auth/Auth';
import { FilterPersistence } from '../../api/filter/filter_persistence';
import {
  ImageIndex,
  ImageIndexFilters,
  ImageIndexOptions,
} from '../../api/images/image_index';
import { Image } from '../../api/images/image';

import Vue from 'vue';

export default Vue.component('image-index', {
  props: ['courseId'],
  data() {
    return {
      fieldFilters: {} as ImageIndexFilters,
      courseFilter: '',
      headers: [
        { text: 'Course', value: 'course_name' },
        { text: 'View', value: 'view' },
      ],
      loading: true,
      loadingText: 'Loading Data...',
      imageCount: -1,
      images: [] as Image[],
      options: {} as ImageIndexOptions,
      perPage: ImageIndex.PER_PAGE,
      pageNo: 1 as number,
      showFilters: true as boolean,
      sortDesc: [] as boolean[],
      sortBy: [] as string[],
    };
  },
  mounted() {
    this.loadFilters();
    // We call this after loadFilters since some field filters are provided as props.
    this.updateFilters();
    this.refreshTable();
  },
  computed: {
  isAdmin(): boolean {
    return Auth.isAdmin();
  },
    showNewImageButton(): boolean {
      return (
        this.isAdmin &&
        this.courseId &&
        this.images.length === 0 &&
        !this.loading
      );
    },
  },
  methods: {
    createNewImage() {
      this.$router.push({
        name: 'image',
        params: { id: 'new', course_id: this.courseId },
      });
    },
    refreshTable() {
      if (this.courseId) {
        this.showFilters = false;
      }
      this.options.sortDesc = this.sortDesc;
      this.options.sortBy = this.sortBy;
      this.options.page = this.pageNo;
      this.options.itemsPerPage = this.perPage;
      this.options.filters = this.fieldFilters;
      ImageIndex.getData(this.options).then((response) => {
        this.images = ImageIndex.parseResponse(response.data);        
        this.loading = false;
      });
      ImageIndex.getCount(this.fieldFilters).then((response) => {
        this.imageCount = response.data;
      });
    },
    search() {
      this.pageNo = 1;
      this.refreshTable();
    },
    maybeSearch(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.updateFilters();
        FilterPersistence.saveFieldFilterState(
          this.$router,
          'manage-images',
          this.fieldFilters,
        );
        this.search();
      }
    },
    loadFilters() {
      const filter = FilterPersistence.getFieldFiltersFromUrl(this.$route);
      if (!filter) {
        return;
      }
      this.fieldFilters = filter;

      this.courseFilter = this.fieldFilters.course_name;
    },
    updateFilters() {
      this.fieldFilters = {
        course_id: this.courseId,
        course_name: this.courseFilter,
      };
    },
  },
  watch: {
    pageNo: {
      handler() {
        this.refreshTable();
      },
    },
    perPage: {
      handler() {
        this.refreshTable();
      },
    },
    sortDesc: {
      handler() {
        this.refreshTable();
      },
    },
  },
});
